import { spotifyAxios } from './spotifyAxios';
export class Http {
    constructor(accessToken) {
        this.accessToken = accessToken;
    }
    getAccessToken() {
        return this.accessToken;
    }
    setAccessToken(accessToken) {
        this.accessToken = accessToken;
    }
    get(url, config) {
        return spotifyAxios(url, 'GET', this.accessToken, config);
    }
    post(url, config) {
        return spotifyAxios(url, 'POST', this.accessToken, config);
    }
    put(url, config) {
        return spotifyAxios(url, 'PUT', this.accessToken, config);
    }
    delete(url, config) {
        return spotifyAxios(url, 'DELETE', this.accessToken, config);
    }
}
//# sourceMappingURL=Http.js.map